<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div class="main main-raised">
      <div class="section profile-content">
        <div class="text-center">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30 md-medium-size-25 md-small-size-0"></div>
            <div class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100">
              <change-conference />
              <profile-settings v-if="isLoggedIn" />
              <change-password v-if="isLoggedIn" />
            </div>
            <div class="md-layout-item md-size-30 md-medium-size-25 md-small-size-0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import ProfileSettings from "./components/Profile/ProfileSettings";
import ChangePassword from "./components/Profile/ChangePassword";
import ChangeConference from "./components/Profile/ChangeConference";
import { mapGetters } from "vuex";
import PageHeader from "./layout/PageHeader";

export default {
  components: {
    ProfileSettings,
    ChangePassword,
    ChangeConference,
    PageHeader
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "user/isLoggedIn",
      conference: "conference/current",
      language: "language/current"
    })
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "profile-page",
  data() {
    return {
      image: require("@/assets/img/conference/landing-bg-new.png")
    };
  }
};
</script>

<style lang="scss" scoped>
.noTopBottomMargins {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  font-size: 0.85rem;
}
</style>
